export default function UpdateBanner({ onRefresh }) {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        background: "#222",
        color: "#fff",
        padding: "12px",
        textAlign: "center",
        zIndex: 9999,
      }}
    >
      🚀 A new version is available.
      <button
        style={{ marginLeft: 12, padding: "6px 12px" }}
        onClick={onRefresh}
      >
        Refresh
      </button>
    </div>
  );
}
